export function currencyFractionDigits(currencyCode: string): number {
    try {
        return new Intl.NumberFormat('en', { style: 'currency', currency: currencyCode }).resolvedOptions().maximumFractionDigits ?? 2;
    } catch {
        return 2;
    }
}

export function roundCurrency(amount: number, currencyCode: string): number {
    const digits = currencyFractionDigits(currencyCode);
    const factor = 10 ** digits;
    return Math.round((amount + Number.EPSILON * Math.max(1, Math.abs(amount))) * factor) / factor;
}

export function orderLineAmounts(quantity: number, unitPrice: number, taxRate: number, currencyCode: string,
        discount = 0): { subtotal: number; discount: number; tax: number; total: number } {
    const subtotal = roundCurrency(quantity * unitPrice, currencyCode);
    const roundedDiscount = roundCurrency(discount, currencyCode);
    const tax = roundCurrency((subtotal - roundedDiscount) * taxRate / 100, currencyCode);
    return { subtotal, discount: roundedDiscount, tax, total: roundCurrency(subtotal - roundedDiscount + tax, currencyCode) };
}

export function unitPriceForTargetNet(quantity: number, targetNet: number, discount: number, currencyCode: string): number | null {
    if (!Number.isFinite(quantity) || quantity <= 0 || !Number.isFinite(targetNet) || targetNet < 0
            || !Number.isFinite(discount) || discount < 0 || roundCurrency(targetNet, currencyCode) !== targetNet) return null;
    const priceUnits = Math.round((targetNet + roundCurrency(discount, currencyCode)) / quantity * 100_000_000);
    if (!Number.isSafeInteger(priceUnits)) return null;
    for (const offset of [0, -1, 1]) {
        const price = (priceUnits + offset) / 100_000_000;
        const amounts = orderLineAmounts(quantity, price, 0, currencyCode, discount);
        if (price >= 0 && roundCurrency(amounts.subtotal - amounts.discount, currencyCode) === targetNet) return price;
    }
    return null;
}
